// extracted by mini-css-extract-plugin
export default {"split":"TZwBwKieeO6tuFCfGCuB","rail":"YVeBdBprBAeIJU1dYnwb","policy-table":"N47mf89phiNVrT7g_mXH","odd-row":"NsqlHsaFeIDc3p7edUYk","even-row":"FtMpzUJqzWuxAee4ZKxA"};